import type JCE from '@chesscom/js-chess-engine';
import type { MachineService } from 'src/utils/state-machine';
import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { MoveListComponent } from 'components/move-list/config/types';
import type { VariationPopoverProps } from '../store/types';

export enum States {
  NodeSelected = 'nodeSelected',
  NoNodeSelected = 'noNodeSelected',
}

export enum Actions {
  LOAD_LINE = 'LOAD_LINE',
  SELECT_NODE = 'SELECT_NODE',
  DESELECT_NODE = 'DESELECT_NODE',
}

export type Send = MachineService<ActionValues>['send'];

export type ActionValues = {
  [Actions.DESELECT_NODE]: undefined;
  [Actions.SELECT_NODE]: {
    node: MoveListComponent.NodeModel | undefined;
    disableScrollIfScrolledUp?: boolean;
  };
  [Actions.LOAD_LINE]: {
    lines: JCE.Line[] | undefined;
    result: string | null;
    node: MoveListComponent.NodeModel | undefined;
  };
};

export interface EventHandlers {
  selectNode: (ids: { line: number; move: number }, event?: MouseEvent) => void;
  selectPopoverMove: (selectedIndex: VariationPopoverProps['selectedIndex']) => void;
  setSelectedNodeEl: (nodeElement: HTMLElement) => void;
  openContextMenu: (node: MoveListComponent.NodeModel, mouseEvent?: MouseEvent) => void;
  closeContextMenu: () => void;
  openVariationsPopover: () => void;
  closeVariationsPopover: () => void;
  handleContextMenuAction: <Data>(
    action: string,
    payload?: ContextMenu.HandlerPayload<Data>,
  ) => void;
  clickComment: (ids: JCE.Ids) => void;
  updateComment: (comment: MoveListComponent.Comment, text: string | undefined) => void;
  handleSelectedNodeChange: () => void;
  scrollToMoveNode(nodeEl: HTMLElement | null, options: { scrollToTop?: boolean }): void;
}
